/* ============================================================
   Atelier Montfort — animations et interactions
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- découpage des titres en mots ---------- */
  function splitWords(root) {
    (root || document).querySelectorAll('.mbtb-words:not([data-split])').forEach(function (el) {
      el.setAttribute('data-split', '');
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      var i = 0;
      nodes.forEach(function (node) {
        if (!node.nodeValue.trim()) return;
        var frag = document.createDocumentFragment();
        node.nodeValue.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var span = document.createElement('span');
          span.className = 'mbtb-word';
          span.style.setProperty('--d', (i * 0.045).toFixed(3) + 's');
          span.textContent = part;
          frag.appendChild(span);
          i++;
        });
        node.parentNode.replaceChild(frag, node);
      });
    });
  }

  /* ---------- apparition au défilement ---------- */
  var io = null;
  function observe(root) {
    var targets = (root || document).querySelectorAll('.mbtb-anim:not([data-obs]), .mbtb-banner:not([data-obs])');
    if (!targets.length) return;
    if (reduce) {
      targets.forEach(function (el) { el.setAttribute('data-obs', ''); el.classList.add('mbtb-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mbtb-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    targets.forEach(function (el) {
      el.setAttribute('data-obs', '');
      io.observe(el);
      /* filet de sécurité : le rafraîchissement du bfcache sur Safari/iOS
         peut cesser d'émettre des callbacks IntersectionObserver, laissant
         le bloc invisible (opacity:0) même une fois entré dans l'écran.
         Un délai de secours force son apparition si besoin. */
      setTimeout(function () {
        if (!el.classList.contains('mbtb-in')) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('mbtb-in');
        }
      }, 2500);
    });
  }
  /* filet de sécurité global : si un bloc reste bloqué invisible malgré
     tout (script interrompu ailleurs sur la page, bug navigateur), on le
     révèle dès qu'il entre dans l'écran, en plus de l'IntersectionObserver. */
  function revealVisiblePending() {
    document.querySelectorAll('.mbtb-anim[data-obs]:not(.mbtb-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.05 && r.bottom > -100) el.classList.add('mbtb-in');
    });
  }

  /* ---------- parallaxe ---------- */
  var parallaxItems = [];
  function collectParallax(root) {
    (root || document).querySelectorAll('[data-parallax]:not([data-px])').forEach(function (el) {
      el.setAttribute('data-px', '');
      parallaxItems.push({ el: el, amount: parseFloat(el.getAttribute('data-parallax')) || 0.3 });
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking || reduce) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parallaxItems.forEach(function (item) {
        var r = item.el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        var shift = -progress * item.amount * 100;
        var target = item.el.matches('.mbtb-banner__media, .mbtb-split__media') ? item.el.querySelector('img') : item.el;
        if (target) target.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)' + (target.dataset.keepScale || '');
      });
      ticking = false;
    });
  }

  /* ---------- décalage vertical des témoignages ---------- */
  var testiItems = [];
  function collectTesti(root) {
    (root || document).querySelectorAll('[data-testi-shift]:not([data-ts])').forEach(function (el) {
      el.setAttribute('data-ts', '');
      testiItems.push({ el: el, shift: parseFloat(el.getAttribute('data-testi-shift')) || 0 });
    });
  }
  function onScrollTesti() {
    if (reduce || window.innerWidth < 900) return;
    var vh = window.innerHeight;
    testiItems.forEach(function (item) {
      var r = item.el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var progress = (r.top + r.height / 2 - vh / 2) / vh;
      item.el.style.transform = 'translate3d(0,' + (-progress * item.shift).toFixed(2) + 'px,0)';
    });
  }

  /* ---------- curseur avant / après ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('.mbtb-compare:not([data-cmp])').forEach(function (el) {
      el.setAttribute('data-cmp', '');
      var dragging = false;
      function setPos(clientX) {
        var r = el.getBoundingClientRect();
        var pct = ((clientX - r.left) / r.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        el.style.setProperty('--pos', pct + '%');
      }
      el.addEventListener('pointerdown', function (e) {
        dragging = true;
        el.setPointerCapture(e.pointerId);
        setPos(e.clientX);
      });
      el.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
      el.addEventListener('pointerup', function () { dragging = false; });
      el.addEventListener('pointercancel', function () { dragging = false; });
      el.addEventListener('keydown', function (e) {
        var cur = parseFloat(el.style.getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft') { el.style.setProperty('--pos', Math.max(0, cur - 4) + '%'); e.preventDefault(); }
        if (e.key === 'ArrowRight') { el.style.setProperty('--pos', Math.min(100, cur + 4) + '%'); e.preventDefault(); }
      });
    });
  }

  function boot(root) {
    splitWords(root);
    observe(root);
    collectParallax(root);
    collectTesti(root);
    initCompare(root);
    onScroll();
    onScrollTesti();
  }

  function ready() {
    boot(document);
    window.addEventListener('scroll', function () { onScroll(); onScrollTesti(); revealVisiblePending(); }, { passive: true });
    window.addEventListener('resize', function () { onScroll(); onScrollTesti(); revealVisiblePending(); }, { passive: true });
    window.addEventListener('pageshow', revealVisiblePending);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  /* rechargement des sections dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();


/* ============================================================
   Pages légales — enrichissement PUREMENT ADDITIF.
   Le design est porté par le CSS sur le balisage natif Shopify.
   Ce script n'ajoute que du confort : encadrés, sommaire, liens.
   S'il échoue, la page reste correctement mise en forme.
   ============================================================ */
(function () {
  'use strict';

  var LABELS = {
    'privacy-policy': 'Politique de confidentialité',
    'refund-policy': 'Politique de retour',
    'shipping-policy': 'Politique d’expédition',
    'terms-of-service': 'Conditions d’utilisation',
    'legal-notice': 'Mentions légales'
  };

  function enrich() {
    var cur0 = (location.pathname.split('/').pop() || '').trim();
    var h1 = document.querySelector('.shopify-policy__title h1');
    if (h1 && LABELS[cur0]) { h1.textContent = LABELS[cur0]; document.title = LABELS[cur0] + ' – Atelier Montfort'; }
    var body = document.querySelector('.shopify-policy__body');
    if (!body || body.dataset.mbtb) return;
    body.dataset.mbtb = '1';

    /* 1. encadrés juridiques ⚖️ */
    body.querySelectorAll('p, div').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (t.indexOf('⚖') === 0 && el.children.length < 3) {
        el.classList.add('mbtb-legal__note');
        el.innerHTML = el.innerHTML.replace(/⚖️?/, '').trim();
      }
    });

    /* 2. badge de dernière mise à jour */
    var first = body.querySelector('p');
    if (first && /derni[eè]re mise [aà] jour/i.test(first.textContent || '')) {
      first.classList.add('mbtb-legal__updated');
    }

    /* 4. liens vers les autres documents */
    var current = (location.pathname.split('/').pop() || '').trim();
    var others = Object.keys(LABELS).filter(function (k) { return k !== current; });
    if (others.length) {
      var nav = document.createElement('nav');
      nav.className = 'mbtb-legal__others';
      var h = '<p>Nos autres documents</p><ul>';
      others.forEach(function (k) { h += '<li><a href="/policies/' + k + '">' + LABELS[k] + '</a></li>'; });
      nav.innerHTML = h + '</ul>';
      body.appendChild(nav);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enrich);
  else enrich();
})();


/* ---------------------------------------------------------------
   Notification de vente récente
   --------------------------------------------------------------- */
(function () {
  var root = document.getElementById('mbtb-pop');
  var data = document.getElementById('mbtb-pop-data');
  if (!root || !data) return;

  var CLE = 'mbtb-pop-off';
  try { if (sessionStorage.getItem(CLE)) return; } catch (e) {}

  var ventes;
  try { ventes = JSON.parse(data.textContent); } catch (e) { return; }
  if (!ventes || !ventes.length) return;

  var lire = function (a, d) { var n = parseFloat(root.getAttribute(a)); return isNaN(n) ? d : n; };
  var PREMIER = lire('data-first', 9) * 1000;
  var VISIBLE = lire('data-show', 6) * 1000;
  var ENTRE_MIN = lire('data-gap-min', lire('data-gap', 25) * 0.8) * 1000;
  var ENTRE_MAX = lire('data-gap-max', lire('data-gap', 25) * 1.5) * 1000;
  var ENTRE_FIXE = lire('data-gap-after', 60) * 1000;
  var MAX_PAR_PAGE = lire('data-max', 4);

  var img = root.querySelector('[data-pop-img]');
  var who = root.querySelector('[data-pop-who]');
  var where = root.querySelector('[data-pop-where]');
  var what = root.querySelector('[data-pop-what]');
  var when = root.querySelector('[data-pop-when]');
  var link = root.querySelector('[data-pop-link]');

  /* « il y a … » à partir de la date réelle de la vente */
  function ilYA(iso) {
    var s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
    var m = Math.floor(s / 60), h = Math.floor(m / 60), j = Math.floor(h / 24);
    if (m < 2) return 'à l’instant';
    if (m < 60) return 'il y a ' + m + ' min';
    if (h < 24) return 'il y a ' + h + ' h';
    if (j === 1) return 'hier';
    if (j < 7) return 'il y a ' + j + ' jours';
    var sem = Math.floor(j / 7);
    return sem === 1 ? 'il y a 1 semaine' : 'il y a ' + sem + ' semaines';
  }

  /* on part de la plus récente, dans l'ordre, sans en inventer */
  var index = 0, compte = 0, timer;

  function montre() {
    if (compte >= MAX_PAR_PAGE || index >= ventes.length) return;
    var v = ventes[index++]; compte++;
    if (v.i) { img.src = v.i + (v.i.indexOf('?') > -1 ? '&' : '?') + 'width=160&height=160&crop=center'; img.alt = v.t; }
    who.textContent = v.p;
    where.textContent = v.v || '';
    what.textContent = v.t;
    when.textContent = ilYA(v.d);
    link.href = '/products/' + v.h;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-on'); });
    timer = setTimeout(cache, VISIBLE);
  }

  function cache() {
    root.classList.remove('is-on');
    setTimeout(function () { root.hidden = true; }, 500);
    var pause = compte >= 2 ? ENTRE_FIXE : ENTRE_MIN + Math.random() * (ENTRE_MAX - ENTRE_MIN);
    timer = setTimeout(montre, pause);
  }

  root.querySelector('[data-pop-close]').addEventListener('click', function () {
    clearTimeout(timer);
    root.classList.remove('is-on');
    setTimeout(function () { root.hidden = true; }, 500);
    try { sessionStorage.setItem(CLE, '1'); } catch (e) {}
  });

  timer = setTimeout(montre, PREMIER);
})();

/* ---------------------------------------------------------------
   Bouton PayPal : si le SDK n'a rien rendu après 6 s (bloqueur,
   réseau), on retire le bloc « ou » + squelette plutôt que de
   laisser un rectangle vide
   --------------------------------------------------------------- */
(function () {
  var zone = document.querySelector('.mbtb-pdp__wallets');
  if (!zone) return;
  function rendu() {
    return !!zone.querySelector('iframe, button, [role="button"], .shopify-payment-button__button:not(.shopify-payment-button__button--hidden)');
  }
  var essais = 0;
  var t = setInterval(function () {
    essais++;
    if (rendu()) { clearInterval(t); return; }
    if (essais >= 12) { clearInterval(t); zone.classList.add('is-off'); }
  }, 500);
})();
